import React from 'react';
import './date-range-filter.scss';
import { DateRangeState } from '@zonofi/zono-money-store';
import moment from 'moment';
import { SVGS } from '@zonofi/zono-money-design-system';
import { isToday, isYesterday } from '../utilities';

interface DateRangeFilterProps {
  dateRange: DateRangeState;
  setDateRange: (val: DateRangeState) => void;
  handleCustomRange: () => void;
}

export const DateRangeFilter: React.FC<DateRangeFilterProps> = ({
  dateRange,
  setDateRange,
  handleCustomRange,
}) => {
  const todayRange = isToday(dateRange.startDate, dateRange.endDate);
  const yesterdayRange = isYesterday(dateRange.startDate, dateRange.endDate);
  const items = [
    {
      id: 'today',
      icon: 'T',
      isIcon: false,
      isSelected: todayRange,
      onPress: () => {
        setDateRange({
          startDate: moment().startOf('day').toDate(),
          endDate: moment().endOf('day').toDate(),
        });
      },
    },
    {
      id: 'yesterday',
      icon: 'Y',
      isIcon: false,
      isSelected: yesterdayRange,
      onPress: () => {
        setDateRange({
          startDate: moment().subtract(1, 'day').startOf('day').toDate(),
          endDate: moment().subtract(1, 'day').endOf('day').toDate(),
        });
      },
    },
    {
      id: 'custom',
      icon: SVGS.CalenderIconNew,
      activeIcon: SVGS.CalenderIconWithNew,
      isIcon: true,
      isSelected: !todayRange && !yesterdayRange,
      onPress: handleCustomRange,
    },
  ];
  return (
    <div className="zm-date-range-filter_container font-primary-semibold">
      {items.map(({ id, icon, isIcon, isSelected, onPress, activeIcon }) => (
        <div
          key={id}
          className={`zm-date-range-filter_item ${isSelected ? 'selected' : ''}`}
          onClick={onPress}
        >
          {isIcon ? (
            <img
              src={!todayRange && !yesterdayRange ? activeIcon : icon}
              alt=""
              className="zm-contents"
            />
          ) : (
            <div className="zm-contents">{icon}</div>
          )}
        </div>
      ))}
    </div>
  );
};
